import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { CurrentPlan, SettingsContainerState } from './settings';

const initialState: SettingsContainerState = {};

export const settingsSlice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setCurrentPlan: (state, action: PayloadAction<CurrentPlan | undefined>) => {
      state.currentPlan = action.payload;
    },
  },
});

export const { setCurrentPlan } = settingsSlice.actions;

export default settingsSlice.reducer;
